import { useClaimPromoCodeMutation } from "@/apollo/types";
import { useMountEffect } from "@/hooks/useMountEffect";
import * as Sentry from "@sentry/react";

// Historical URL param name preserved so links shared before the rename keep working.
const LEGACY_PROMO_URL_PARAM = "aff_code";

export function useClaimPromoCode() {
  const [claimPromoCode] = useClaimPromoCodeMutation();

  useMountEffect(async () => {
    const code = new URLSearchParams(window.location.search).get(
      LEGACY_PROMO_URL_PARAM,
    );
    if (code) {
      try {
        // Send the code to the backend to claim it. The endpoint sets a signed
        // cookie used to apply the promo on the user's next subscription.
        await claimPromoCode({
          variables: {
            input: {
              code,
            },
          },
        });

        // Strip the code from the URL so it's not visible / shareable.
        const url = new URL(window.location.href);
        url.searchParams.delete(LEGACY_PROMO_URL_PARAM);
        window.history.replaceState({}, "", url.toString());
      } catch (e) {
        Sentry.captureException(e);
      }
    }
  });
}
